import {FC} from 'react';
import {shallowEqual} from 'react-redux';

import NavLink from '~/common/NavLink/NavLink';
import {Icons, MenuIcons} from '~/common/Icon';
import {UserType} from '~/services/types';
import {useSelector} from '~/store/hooks';
import CardBordered from '~/common/display/CardBordered/CardBordered';

import s from '../styles.module.scss';
import {LinksGroupProps} from './types';

const MyAccountLinks: FC<LinksGroupProps> = ({onClickBack}) => {
  const {mailServerUrl, userType} = useSelector(
    ({profile}) => ({
      userType: profile.data?.userType,
      mailServerUrl: profile.data?.mailServerUrl,
    }),
    shallowEqual
  );

  return (
    <CardBordered className={s.card}>
      <NavLink icon={Icons.myAccount} label="My Account" carretLeft onClick={onClickBack} />
      {mailServerUrl && (
        <NavLink href={mailServerUrl} icon={Icons.myMailbox} label="My Mailbox" asChild />
      )}
      <NavLink href="/profile#/my-reviews" icon={Icons.myReviews} label="My Reviews" asChild />
      <NavLink
        href="/profile#/my-questions"
        icon={Icons.myQa}
        label="My Questions & Answers"
        asChild
      />
      {userType !== UserType.Regular && (
        <NavLink
          href="/profile#/connected-profiles"
          icon={MenuIcons.connectedProfiles}
          label="Connected Profiles"
          asChild
        />
      )}
      <NavLink
        href="/profile#/favorites/search"
        icon={Icons.myFavorites}
        label="Favorites"
        asChild
      />
    </CardBordered>
  );
};

export default MyAccountLinks;
